<template>
  <div v-if="familyStore.selectedFamilyPlan" class="pt-24">
    <h3 class="heading-xs mb-16">Välj antal familjeanslutningar</h3>
    <FamilyAddPlan
      :number-of-family-plans="
        Math.min(familyStore.allowedNumberOfConnections, 2)
      "
    />
  </div>
  <div class="mb-32 mt-16">
    <AppUsp :items="uspItems" usp-direction="col" />
  </div>
</template>

<script lang="ts" setup>
const familyStore = useFamilyStore();

const uspItems = computed(() => {
  return [
    {
      Icon: 'info',
      Label: 'Är ni fler i familjen?',
      SubLabel:
        'Du kan lägga till två familjeanslutningar i taget. Du kan totalt ha 4 st anslutningar (Halebop familj och Surfsim).',
    },
    {
      Icon: 'coin',
      Label: `Abonnemangens totala kostnad: ${familyStore.summary_totalMontlyCost} kr/mån`,
      SubLabel: familyStore.summary_plansToPurchaseText,
    },
  ];
});
</script>

<style scoped></style>
